import { Directive, Input, Output, EventEmitter, ElementRef, HostListener, TemplateRef, ChangeDetectorRef } from '@angular/core';
import { Gesture, GestureController, Platform } from '@ionic/angular';
import { ImpactStyle } from '@capacitor/haptics';
import { FeedbackService, VibrateType } from '../_provider/feedback.service';


@Directive({
  selector: '[swipeback]',
})
export class SwipeBackDirective {

  @Output() swipedBack = new EventEmitter<void>();

  constructor(
    private gestureController: GestureController,
    private elementRef: ElementRef,
    private feedback: FeedbackService,
    private platform: Platform,
    private changedetector: ChangeDetectorRef
  ) { 
    this.registerGesture();
  }
  private registerGesture() {

    if(!this.platform.is("ios")) return

    let swipeBackActive = false;
    let swipebackSuccess = false;
    let swipeContainer = null
    const gesture: Gesture = this.gestureController.create({
      el: this.elementRef.nativeElement,
      gestureName: 'swipeBack',
      direction: "x",
      onStart: (ev) => {
        if(ev.startX <= 50) {
          swipeBackActive = true;
          swipeContainer = document.createElement('div');
          swipeContainer.className = 'swipe-back-container';
          swipeContainer.innerHTML = '<ion-icon name="fa-arrow-left"></ion-icon>'
          swipeContainer.style.top = `${ev.deltaY + ev.startY - 40}px`;
          this.elementRef.nativeElement.appendChild(swipeContainer);
        }
      },
      onMove: (ev) => {
        if(swipeBackActive){
          const scale: number = ev.deltaX / 75
          swipeContainer.style.left = `${(ev.deltaX + ev.startX) / 7}px`;
          swipeContainer.style.opacity = `${scale}`;
          if(scale >= 1)swipebackSuccess = true;
          else swipebackSuccess = false;
          this.changedetector.detectChanges()
        }
      },
      onEnd: () => {
        swipeBackActive = false;
        swipeContainer.classList.add('hide');
        setTimeout(() => swipeContainer.remove(), 200);
        if(swipebackSuccess) {
          this.feedback.hideKeyboardOnIOS().then(()=>{
            this.feedback.vibrate(VibrateType.medium)
            this.swipedBack.emit()
          })
        }
      }
    })
    gesture.enable()
  }
}

